import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

export const EmptyMessageWindow: React.FC = () => {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <RESIDENTS_SVG_COMPONENTS.EMPTY_INBOX 
          width={120} 
          height={120} 
          color={RESIDENTS_DESKTOP_COLORS.ICON_INACTIVE}
        />
      </View>
      <Text style={styles.title}>New Message</Text>
      <Text style={styles.subtitle}>
        Click the "New message" button to start compiling your message
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    paddingVertical: 64,
  },
  iconContainer: {
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    lineHeight: 20,
  },
});

export default EmptyMessageWindow;
